/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
// import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'

import { Grid } from "@material-ui/core";
  import { SiMicrosoftexcel } from 'react-icons/si';
import styles from './AuditLogsReport.module.css'
import { 
  CustomDatePicker, 
  CustomFormGroup, 
  CustomSelect, 
  ValidatingTextField 
} from '../FormComponents'
import { 
  DATE_FORMAT, 
  API_RESOURCE_URLS, 
  DISPLAY_MESSAGES, 
  MESSAGE_TYPE, 
  RESOURCE_TYPE, 
  USER_OPERATIONS, 
  Regex 
} from '../../constants'

import Truckloading from "../../components/CvLoader/Cvloader";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from '../../hocs'
import { setLogin } from '../../redux/features/auth/actions';


const AuditLogsReport = () => {

  const auth = useSelector((state) => state.auth);
const baseUrl = useSelector((state) => state.counter.baseUrl); 
const { showPopup } = usePopupManager();

  const dispatch= useDispatch();

    const [loading, setLoading] = useState(false);

    const [dropDownValue, setDropDownValue] = useState({ value: "", label: "ALL" },);
    const [role, setRole] = useState([
        { value: "", label: "ALL" },
        { value: "DS", label: "Departmental SPOC" },
        { value: "SA", label: "Super Admin" },
        { value: "S", label: "Supervisor" },
        { value: "B", label: "BC Head" },
        { value: "LI", label: "Linkage SPOC" },
        ]);

   const baseDefaultColumns = [
   
    {title: 'Ticket No', field: 'ticket_no'},
    {title: 'Employee Name', field: 'employee_name'},
    {title: 'Access/Role', field: 'access_or_role'},
    {title: 'Creation Date', field: 'creation_date'},
    {title: 'Creation By', field: 'created_by'},
    {title: 'Request ID', field: 'request_id'},
    {title: 'Effective Date', field: 'effective_date'},
    {title: 'End Date', field: 'end_date'},
    {title: 'Modification Request ID', field: 'modification_request_id'},
    {title: 'Modification Date', field: 'modification_date'},
    {title: 'Modified By', field: 'modified_by'},
    {title: 'Status', field: 'status'},
  ];

  const exportToExcel = () => {

    const SelectedRole = dropDownValue.value;
    let headerss = new Headers();
    // const token = sessionStorage.getItem('token'); 
    // const sessionId  = sessionStorage.getItem('sessionId')
    // headerss.append("authorization", `Bearer ${token}`);
    // headerss.append('X-Session-Id', sessionId)
    headerss.append("Content-Type", "application/json");

    const apiFormatedData = {"role_id":SelectedRole};

    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    
      setLoading(true);
      fetch(`${baseUrl}reports/AccessRoleControlAudit`, {
        method: "POST",
        headers: headerss,
        credentials: "include",
        body: apiFormatedDataJson,
      })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        setLoading(false);

        // console.log("Api Master Data: ", responseJson.data);
        if(responseJson.msg=="Success" && responseJson?.data.length !== 0) {
          const exportData = responseJson.data.map(item => {
            const {id, ...rest} = item;
            const reorderedItem = {};
            baseDefaultColumns.forEach(mapping => {
                reorderedItem[mapping.title] = rest[mapping.field];
            });
            return reorderedItem;
          })
          const workbook = XLSX.utils.book_new();
          const worksheet = XLSX.utils.json_to_sheet(exportData);
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, 'AccessControlAuditReport.csv');

        }else{
          setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Data Not Found",
          })
        }
      }).catch((error) => {
        setLoading(false);
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Oops! Something went wrong. Please try again later",
            })
          });
    };

  
     const renderRoles = () => (
        <div className="">
        <Grid
          container
          rowSpacing={2}
        //   style={{ marginTop: "15px" }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item md={6} lg={6} className={styles.gridStyle}>
            <div className="">
              <p><strong>User Role : </strong></p>
            </div>
          </Grid>
          <Grid item md={6} lg={6} style={{ textAlign: 'left' }}>
            <div className="">
                <CustomSelect
                    className={clsx(styles.select, styles.sel2)}
                    isMulti={false}
                    options={role}
                    value={dropDownValue}
                    onChange={(e) => {setDropDownValue(e)}}
                    name="Role"
                />
              </div>
          </Grid>
        </Grid>
      </div>
      );
    
  const renderOther = () => (
    <div className="">
    <Grid
      container
      rowSpacing={2}
      style={{ marginTop: "15px" }}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item md={6} lg={6} className={styles.gridStyle}>
        {/* {renderRoles()} */}
            <div className="">
              <p><strong>Audit Log Report Download here: </strong></p>
            </div>
      </Grid>
      <Grid item md={6} lg={6} style={{ textAlign: 'left' }}>
        <div className="">
            <Button
              className={clsx(styles.actionButton)}
              variant="primary"
              data-testid="confirm-action"
              onClick={() => exportToExcel()}
              startIcon={<SiMicrosoftexcel />}
            >
              Export Report
            </Button>
          </div>
      </Grid>
    </Grid>
  </div>
  );


  return (
    <>
      <div className={styles.formContainer}>
        <CustomFormGroup header='Audit Logs Report' 
          body={renderOther()} 
          />
        {
          loading ? (
            <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
                 <Truckloading />
              </div>):""
        }

      </div>
      </>
   
  );
};

export default AuditLogsReport;

